/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Select_Tea_TypeInputs */

const vi_tea_purchase_select_tea_type = /** @type {(inputs: Tea_Purchase_Select_Tea_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn loại chè`)
};

/**

* @param {Tea_Purchase_Select_Tea_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_select_tea_type = /** @type {((inputs?: Tea_Purchase_Select_Tea_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Select_Tea_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_select_tea_type(inputs)
});